import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import Modal from "react-bootstrap/lib/Modal";
import toastr from "toastr";
import Constants from "../../classes/constants";

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
    return rowIdx % 2 == 0 ? 'color' : 'td-column-function-odd-example';
}

class MyReferralTable extends React.Component {

  constructor() {
    super();
  }

  navigate(url){
     window.open(url);
  }

  render() {
    return (
      <div>
        <BootstrapTable
        data={this.props.referrals}>
        <TableHead dataField="jobDetailsId"
            isKey={true}
            filter={ {type: 'TextFilter', delay: 0,  placeholder: 'Job Details Id'} }
            dataFormat={(cell, row)=> {
              return <OverlayTrigger trigger={['hover']} placement="top">
                <u><a onClick={()=>{this.navigate(Constants.tejaUrl+row.jobLink)}}>{cell}</a></u>
              </OverlayTrigger>
            }}
            dataSort={true}
            columnClassName={ columnClassNameFormat }
            width={60}>Id</TableHead>
          <TableHead dataField="departmentName"
                     filter={ {type: 'TextFilter', delay: 0,  placeholder: 'Department'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     width={160}>Department</TableHead>

          <TableHead dataField="jobTitle"
                                         filter={ {type: 'TextFilter', delay: 0, placeholder: 'Job Title'} }
                                         dataSort={true}
                                         dataFormat={(cell, row)=> {
                                           return <div>
                                             <OverlayTrigger placement="top">
                                                <u><a onClick={()=>{this.navigate(Constants.tejaUrl+row.jobLink)}}>{cell}</a></u>
                                             </OverlayTrigger>
                                           </div>
                                         }}
                                         columnClassName={ columnClassNameFormat }
                                         width={140}>Job Title</TableHead>
         <TableHead
                     isKey={false}
                     hidden={false}
                     columnClassName="leftRightOnlyZero"
                     width={100}
                     dataFormat={(cell, row)=> {
                        return <div>
                          <OverlayTrigger placement="top">
                            <u><a onClick={()=>{this.navigate(Constants.tejaUrl+row.referralCv)}}>View CV</a></u>
                          </OverlayTrigger>
                       </div>
                     }}
                     dataField="id"> </TableHead>
        </BootstrapTable>
      </div>
    );
  }
}

MyReferralTable.propTypes = {};

export default MyReferralTable;





/** WEBPACK FOOTER **
 ** ./src/components/Referral/MyReferralTable.js
 **/